import { SearchScopeType, SourceDocumentType } from 'api/model'
import { CallbackDoc } from 'react-google-drive-picker/dist/typeDefs'

export type FormattedCallbackDoc = {
  type: SourceDocumentType
  name: string
  url: string
  icon_url: string
  document_id: string
  size: number
  description: string
  mime_type: string
  search_scope: SearchScopeType
  tags: string[]
}

function formatGoogleDrivePickerDocuments(docs: CallbackDoc[]): FormattedCallbackDoc[] {
  return docs.map((doc) => {
    return {
      type: SourceDocumentType.gdoc,
      name: doc.name,
      url: doc.url,
      icon_url: doc.iconUrl,
      document_id: doc.id,
      size: doc.sizeBytes,
      description: doc.description,
      mime_type: doc.mimeType,
      search_scope: SearchScopeType.global,
      tags: [],
    }
  })
}

export { formatGoogleDrivePickerDocuments }
